import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import FetchModule from '../../../../Share/Network/FetchModule';
import moment from "moment";

import UserProfile from "../../../../../Component/Normal/UserProfile";

import DefaultProfile from '../../../../../image/DefaultProfile.png';
import { ReactComponent as SearchingSvg } from '../../../../../image/Searching.svg';
import PointInput from "../../../../../Component/MemberComponent/MemberDetail/PointInput";
import CalenderInput from "../../../../../Component/MemberComponent/CalenderInput";
import PointReasonInput from "../../../../../Component/MemberComponent/MemberDetail/PointReasonInput";
import BulkPointMemberSelectView from './BulkPointMemberSelectView';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

export default function PointSaveModal(props) {
  const { memberData, memberShipData, clickedPointHistory, onClickSave, onClickExit } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [memberId, setMemberId] = useState(0);
  const [memberName, setMemberName] = useState('');
  const [memberProfile, setMemberProfile] = useState('');

  const [pointHistoryId, setPointHistoryId] = useState(0);
  const [pointSign, setPointSign] = useState('Plus');
  const [point, setPoint] = useState(0);
  const [approvalDate, setApprovalDate] = useState(moment().format('YYYY.MM.DD'));
  const [reason, setReason] = useState('');
  const [isClickedExpand, setIsClickedExpand] = useState(false);

  const history = useHistory();
  const BulkRef = useRef(null);

  // 활성 회원권 이름 — 오늘 날짜가 startDate~endDate 사이인 회원권 //
  const activeMembershipName = (() => {
    if (!Array.isArray(memberShipData)) return '';

    const today = moment();
    const active = memberShipData.find((data) => {
      return moment(data.startDate).isSameOrBefore(today)
        && moment(data.endDate).isSameOrAfter(today);
    });

    return active ? active.memberShipName : '';
  })();

  // 회원 데이터 정리 //
  useEffect(() => {
    if (memberData !== undefined) {
      setMemberId(memberData.memberId);
      setMemberName(memberData.name);
      setMemberProfile(memberData.profile);
    }
  }, [memberData])

  // 수정할 데이터 클릭시 //
  useEffect(() => {
    if (clickedPointHistory === undefined) return;  
    
    setPointHistoryId(clickedPointHistory.pointHistoryId);
    setPointSign(clickedPointHistory.point >= 0 ? 'Plus' : 'Minus');
    setPoint(clickedPointHistory.point >= 0 ? (clickedPointHistory.point) : (clickedPointHistory.point * -1));
    setApprovalDate(moment(clickedPointHistory.approvalDate).format('YYYY.MM.DD'));
    setReason(clickedPointHistory.reason);
  }, [clickedPointHistory])

  // 포인트 추가 및 차감 텍스트 정리 //
  function decidePointDeltaText() {
    let finalPoint = point || 0;

    if (pointSign === 'Plus') return t('memberDetail.pointSaveModal.pointAdd').replace('{point}', parseInt(finalPoint).toLocaleString('ko-KR'));
    else return t('memberDetail.pointSaveModal.pointSubtract').replace('{point}', parseInt(finalPoint).toLocaleString('ko-KR'));
  }

  // 포인트 내역 추가 수정 저장 버튼 클릭시 //
  function onClickSaveButton() {
    let finalPoint = point || 0;
    let finalApprovalDate = moment(approvalDate).format('YYYY-MM-DDTHH:mm:ss');

    if (pointSign === 'Minus') finalPoint *= -1;

    // 일괄 지급 모드 — POST /api2/point/saves //
    if (isClickedExpand) {
      const memberIds = BulkRef.current?.getSelectedMemberIds() || [];

      if (memberIds.length === 0) {
        alert(t('memberDetail.pointSaveModal.alertNoTargets'));
        return;
      }

      let requestData = {
        memberIds: memberIds,
        point: finalPoint,
        approvalDate: finalApprovalDate,
        reason: reason
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('point/saves', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('memberDetail.pointSaveModal.alertGrantSuccess'));
            onClickExit();
          }
          else if (responseData.status === 201) {
            alert(t('memberDetail.pointSaveModal.alertNoTargets'));
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();

      return;
    }

    onClickSave(memberId, pointHistoryId, finalPoint, finalApprovalDate, reason);
  }

  return (
    <TotalModalWrapper>
      <ModalView $isDark={isDark}>
        <TopComponentWrapper>
          <TitleWrapper>
            {
              !isClickedExpand &&
              <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{memberName} - </Text>
            }
            <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberDetail.pointSaveModal.title')}</Text>
          </TitleWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickExit}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.pointSaveModal.btnCancel')}</Text>
            </ExitButton>
            <SaveButton onClick={onClickSaveButton}>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('memberDetail.pointSaveModal.btnSave')}</Text>
            </SaveButton>
          </ButtonWrapper>
        </TopComponentWrapper>
        <MemberInfoWrapper $isHidden={isClickedExpand}>
          <ProfileBox>
            <UserProfile profile={memberProfile} defaultProfile={DefaultProfile} />
          </ProfileBox>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{activeMembershipName}</Text>
        </MemberInfoWrapper>
        <PointInfoWrapper>
          <ComponentWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.pointSaveModal.pointsToApply')}</Text>
            <PointButtonWrapper>
              <PointAddButton isClicked={pointSign === 'Plus'} onClick={() => setPointSign('Plus')}>
                <PlusBox>
                  <Stick width={16} height={3} isClicked={pointSign === 'Plus'} />
                  <Stick width={3} height={16} isClicked={pointSign === 'Plus'} />
                </PlusBox>
              </PointAddButton>
              <PointSubtractButton isClicked={pointSign === 'Minus'} onClick={() => setPointSign('Minus')}>
                <PlusBox>
                  <Stick width={16} height={3} isClicked={pointSign === 'Minus'} />
                </PlusBox>
              </PointSubtractButton>
              <PointInput value={point} setValue={setPoint}/>
            </PointButtonWrapper>
          </ComponentWrapper>
          <ComponentWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.pointSaveModal.pointApplyDate')}</Text>
            <CalenderInput
              value={approvalDate}
              setValue={setApprovalDate}
              selectClickFn={() => {}}
              className='ApprovalCalender'
              clickFn={() => {}}
              placeholder={t('memberDetail.pointSaveModal.placeholderApplyDate')}
              width={150}
              height={32}
              disabled={false} />
          </ComponentWrapper>
          <ReasonBoxWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.pointSaveModal.reason')}</Text>
            <PointReasonInput value={reason} setValue={setReason}/>
          </ReasonBoxWrapper>
        </PointInfoWrapper>
        <DivisionLineWrapper>
          <DivisionLine />
        </DivisionLineWrapper>
        <BulkPointButtonWrapper $isHidden={isClickedExpand}>
          <BulkPointButton onClick={() => setIsClickedExpand(!isClickedExpand)}>
            <SearchingIcon />
            <Text fontFmaily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='default'>{t('memberDetail.pointSaveModal.bulkPointDistribution')}</Text>
          </BulkPointButton>
        </BulkPointButtonWrapper>
        <BulkSelectWrapper $isVisible={isClickedExpand}>
          <BulkPointMemberSelectView ref={BulkRef} startDate={approvalDate} />
        </BulkSelectWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px 0 20px 20px;

  box-sizing: border-box;
  width: 900px;

  gap: 10px;

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const TopComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding-right: 20px;
  
  box-sizing: border-box;
  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 120px;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const MemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;

  padding-right: 20px;
  margin-top: ${props => props.$isHidden ? '0' : '20px'};

  box-sizing: border-box;
  width: 100%;
  max-height: ${props => props.$isHidden ? '0' : '200px'};

  opacity: ${props => props.$isHidden ? 0 : 1};
  overflow: hidden;
  pointer-events: ${props => props.$isHidden ? 'none' : 'auto'};

  transition: all 0.3s ease-in-out;
`;

const ProfileBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border-radius: 2px;

  overflow: hidden;

  & img {
    object-fit: cover;
  }
`;

const DivisionLineWrapper = styled.div`
  padding: 20px 20px 20px 0;
  
  box-sizing: border-box;
  width: 100%;
`;

const DivisionLine = styled.div`
  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const PointInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  padding-right: 20px;
  
  box-sizing: border-box;
  width: 100%;

  gap: 15px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 5px;
`;

const PointButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 5px;
`;

const PointAddButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 64px;
  height: 32px;

  border-radius: 5px;
  border: 1px solid ${props => props.isClicked ? props.theme.subKey : props.theme.buttonStroke};
  background-color: ${props => props.isClicked ? props.theme.subKey : props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PointSubtractButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 64px;
  height: 32px;

  border-radius: 5px;
  border: 1px solid ${props => props.theme.buttonStroke};
  background-color: ${props => props.isClicked ? props.theme.pointRed : props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PlusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 14px;
`;

const Stick = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 2px;
  background-color: ${props => props.isClicked ? props.theme.white : props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const ReasonBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 5px;
`;

const BulkPointButtonWrapper = styled.div`
  display: ${props => props.$isHidden ? 'none' : 'flex'};
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  padding-right: 20px;
  
  box-sizing: border-box;
  width: 100%;
`;

const BulkSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: ${props => props.$isVisible ? '700px' : '0'};

  opacity: ${props => props.$isVisible ? 1 : 0};
  overflow: hidden;
  pointer-events: ${props => props.$isVisible ? 'auto' : 'none'};

  transition: all 0.4s ease-in-out;
`;

const BulkPointButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 10px;

  height: 40px;

  gap: 5px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};
`;

const SearchingIcon = styled(SearchingSvg)`
  width: 20px;
  height: 20px;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;